import style from "./style.module.scss";

export default function LandingPageFooter({ id = "" }: { id?: string }) {
  const footerContent = [
    {
      id: "typography-footer-section-alamat",
      title: "Alamat",
      content: `Jl. Jend. Sudirman No. Kav 44-46 RT. 14/ RW. 1 Bend. Hilir, Tanah Abang
          Jakarta Pusat, DKI Jakarta, 10210`,
      link: "",
    },
  ];

  return (
    <footer
      id={id}
      className={style.footer_landingpage}
      // style={{
      //   backgroundImage: `url(${process.env.NEXT_PUBLIC_IMAGES}/footer.webp)`,
      // }}
    >
      <div className={style.footer_detail}>
        <img
          id={"image-footer-bri"}
          style={{ width: "150px", height: "57px" }}
          src={`${process.env.NEXT_PUBLIC_IMAGES}/logo-bri.webp`}
          alt="logo-bri"
        />
        {footerContent.map((item: any, index: number) => (
          <div
            key={index}
            style={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "flex-start",
            }}
          >
            <div
              id={`typography-footer-section-${item.id}`}
              style={{
                fontFamily: "BRI-Digital",
                fontWeight: "bold",
                fontSize: "16px",
                lineHeight: "28px",
                color: "white",
                cursor: "default",
              }}
            >
              {item?.title}
            </div>
            {item.link.length ? (
              <a
                href={item.link}
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  fontFamily: "BRI-Digital",
                  fontWeight: 400,
                  fontSize: "16px",
                  lineHeight: "28px",
                  color: "#B4D4FC",
                  width: `${item.link.length ? "max-content" : ""}`,
                }}
              >
                {item?.content}
              </a>
            ) : (
              <div
                style={{
                  fontFamily: "BRI-Digital",
                  fontWeight: 400,
                  fontSize: "16px",
                  lineHeight: "28px",
                  color: "#FFF",
                  whiteSpace: "pre-line",
                }}
              >
                {item?.content}
              </div>
            )}
          </div>
        ))}
      </div>
      <div id={"typography-footer-copyright"} className={style.copyright}>
        {`© ${new Date()?.getFullYear()} PT Bank Rakyat Indonesia (Persero) Tbk. | All Rights Reserved.`}
      </div>
    </footer>
  );
}
